// extracted by mini-css-extract-plugin
module.exports = {"main-component":"emptyActor_main-component__3wB9T"};